import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Dashboard from '@/views/Dashboard'
import Projects from '@/views/Projects'
import Project from '@/views/Project'
import FieldworkRequests from '@/views/FieldworkRequests'
import FieldworkRequest from '@/views/FieldworkRequest'
import UserInfo from '@/views/UserInfo'
import Investigations from '@/views/Investigations'
import Investigation from '@/views/Investigation'
import Undertakings from '@/views/Undertakings'
import Undertaking from '@/views/Undertaking'
import Map from '@/views/MapNew'
import FileSearches from '@/views/FileSearches'
import FileSearch from '@/views/FileSearch'
import FileSearchResults from '@/views/FileSearchResults'
import FileSearchPayment from '@/views/FileSearchPayment'
import FileSearchPaymentReceipt from '@/views/FileSearchPaymentReceipt'
import FileSearchPaymentFail from '@/views/FileSearchPaymentFail'
import SiteNumberRequest from '@/views/SiteNumberRequest'
import SiteNumberRequests from '@/views/SiteNumberRequests'
import CulturalResourceRecording from '@/views/CulturalResourceRecording'
import CulturalResourceGroup from '@/views/CulturalResourceGroup'
import Isolate from '@/views/Isolate'
import Editor from '@/views/Editor'
import Organization from '@/views/Organization'
import BuildingReconForm from '@/views/BuildingReconForm'
import BuildingReconForms from '@/views/BuildingReconForms'
import BuildingSurvey from '@/views/BuildingSurvey'
import BuildingSurveys from '@/views/BuildingSurveys'
import MoasPas from '@/views/MoasPas'
import Moa from '@/views/Moa'
import Pa from '@/views/Pa'
import CulturalResources from '@/views/CulturalResources'
import CulturalResource from '@/views/culturalResource'
import BuildingReconSiteSelection from '@/views/buildingReconSiteSelection'
import Callback from '@/views/callback'
import LetterTemplates from '@/views/LetterTemplates'
import LetterTemplate from '@/views/LetterTemplate'
import UserAdministration from '@/views/UserAdministration'
//import RadioCarbonReport from '@/components/RadioCarbonReport'
import ProjectsDelete from '@/views/ProjectsDelete'
import E106Compliance from '@/views/E106Compliance'
import E106Compliances from '@/views/E106Compliances'
import BlmDataExport from '@/views/BlmDataExport'
import HelpInfo from '@/views/HelpInfo'
import Reports from '@/views/Reports'
import ShpoAnnualReport from '@/views/Reports/ShpoAnnualReport'
import PublicE106 from '@/views/PublicE106'

import loggingService from '../services/util/loggingService'
import roleService from '../services/roleService'
import userService from '../services/userService.js'
//using vuex store state
import store from '@/store/index'

Vue.use(Router)

var isDebug = false

function isAuthenticated () {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
}

function userHasRoleList () {
    let shpoUserDto = store.state.auth.shpoUserDto
    //check if user has roleList or not
    return !!shpoUserDto.roleList
}

function setLoginPlaceholder (placeholder) {
    localStorage.setItem('loginPlaceholder', placeholder)
}

function requireAuth (to, from, next) {
    loggingService.log(isDebug, 'router_index', 'requireAuth, to: ' + to.fullPath)
    setLoginPlaceholder(to.fullPath)
    if (!isAuthenticated()) {
        // redirect to User Info if user has no roleList
        loggingService.log(isDebug, 'router_index', 'not logged in')
        next({
            path: '/'
        })
    } else if (!userHasRoleList()) {
        loggingService.log(isDebug, 'router_index', 'user role list not set up')
        next({
            path: '/UserInfo'
        })
    } else {
        //check user role acccess
        let userRoleList = store.state.auth.shpoUserDto.roleList || []
        //check if going to /MapPublic and public user role
        if (to.path !== '/MapPublic' && userService.hasRoleCheck(userRoleList, [roleService.RoleEnum.PublicUser])) {
            next({ path: '/' })
        } else if (to.matched.some(record => record.meta && record.meta.userRoles)) {
            //let allowedRoleList = record => record.meta.userRoles
            if (userService.hasRoleCheck(userRoleList, to.meta.userRoles)) {
                loggingService.log(isDebug, 'router_index', 'user has access, going')
                next()
            } else {
                loggingService.log(isDebug, 'router_index', 'user has no access, redirect to home')
                next({ path: '/' })
            }
        } else if (to.matched.some(record => record.meta && record.meta.restrictedRoles)) {
            //check if user has reststricted roles
            if (userService.hasRoleCheck(userRoleList, to.meta.restrictedRoles)) {
                loggingService.log(isDebug, 'router_index', 'user has no access, redirect to home')
                next({ path: '/' })
            } else {
                loggingService.log(isDebug, 'router_index', 'user has access, going')
                next()
            }
        } else {
            loggingService.log(isDebug, 'router_index', 'logged in, going.')
            next()
        }
    }
}

function check () {
    loggingService.log(isDebug, 'router_index', 'Check no auth')
}

const router = new Router({
    mode: 'history',
    routes: [
        { path: '/', name: 'Index', component: Index, beforeEnter: check },
        { path: '/UserInfo', name: 'UserInfo', component: UserInfo },
        { path: '/Dashboard', name: 'Dashboard', component: Dashboard, beforeEnter: requireAuth },
        { path: '/Projects', name: 'Projects', component: Projects, beforeEnter: requireAuth },
        { path: '/Project/:projectId?', name: 'Project', component: Project, beforeEnter: requireAuth },
        { path: '/FieldworkRequests', name: 'FieldworkRequests', component: FieldworkRequests, beforeEnter: requireAuth },
        { path: '/FieldworkRequest/:fieldworkRequestId?', name: 'FieldworkRequest', component: FieldworkRequest, beforeEnter: requireAuth },
        { path: '/Investigations', name: 'Investigations', component: Investigations, beforeEnter: requireAuth },
        { path: '/Investigation/:investigationId?', name: 'Investigation', component: Investigation, beforeEnter: requireAuth },
        {
            path: '/Undertakings',
            name: 'Undertakings',
            component: Undertakings,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.ShpoRoleList.concat(roleService.AgencyRoleList) }
        },
        {
            path: '/Undertaking/:undertakingId?',
            name: 'Undertaking',
            component: Undertaking,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.ShpoRoleList.concat(roleService.AgencyRoleList) }
        },
        { path: '/Map', name: 'Map', component: Map, props: true, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/MapPublic', name: 'MapPublic', component: Map, props: true, beforeEnter: requireAuth },
        { path: '/Editor', name: 'Editor', component: Editor, beforeEnter: requireAuth, meta: { userRoles: roleService.AdminRoleList } },
        { path: '/FileSearches', name: 'FileSearches', component: FileSearches, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/FileSearch/:fileSearchId?', name: 'FileSearch', component: FileSearch, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/FileSearchResults/:fileSearchId?', name: 'FileSearchResults', component: FileSearchResults, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/FileSearchPayment/:fileSearchId?', name: 'FileSearchPayment', component: FileSearchPayment, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/FileSearchPaymentReceipt/:fileSearchId?', name: 'FileSearchPaymentReceipt', component: FileSearchPaymentReceipt, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/FileSearchPaymentFail/:fileSearchId?', name: 'FileSearchPaymentFail', component: FileSearchPaymentFail, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/SiteNumberRequest/:siteNumberRequestId?', name: 'SiteNumberRequest', component: SiteNumberRequest, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/SiteNumberRequests', name: 'SiteNumberRequests', component: SiteNumberRequests, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/CulturalResourceRecording/:culturalResourceRecordingId', name: 'CulturalResourceRecording', component: CulturalResourceRecording, beforeEnter: requireAuth, props: true },
        { path: '/Isolate/:isolateId?', name: 'Isolate', component: Isolate, beforeEnter: requireAuth, props: true },
        { path: '/CulturalResourceGroup/:culturalResourceGroupId?', name: 'CulturalResourceGroup', component: CulturalResourceGroup, beforeEnter: requireAuth, props: true },
        {
            path: '/Organization',
            name: 'Organization',
            component: Organization,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        { path: '/BuildingReconForm/:buildingReconFormId?', name: 'BuildingReconForm', component: BuildingReconForm, beforeEnter: requireAuth },
        { path: '/BuildingReconForms', name: 'BuildingReconForms', component: BuildingReconForms, beforeEnter: requireAuth },
        { path: '/BuildingSurvey/:buildingSurveyId?', name: 'BuildingSurvey', component: BuildingSurvey, beforeEnter: requireAuth },
        { path: '/BuildingSurveys', name: 'BuildingSurveys', component: BuildingSurveys, beforeEnter: requireAuth },
        {
            path: '/MoasPas',
            name: 'MoasPas',
            component: MoasPas,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.ShpoRoleList.concat(roleService.AgencyRoleList) }
        },
        {
            path: '/Moa/:moaId?',
            name: 'Moa',
            component: Moa,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.ShpoRoleList.concat(roleService.AgencyRoleList) }
        },
        {
            path: '/Pa/:paId?',
            name: 'Pa',
            component: Pa,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.ShpoRoleList.concat(roleService.AgencyRoleList) }
        },
        { path: '/CulturalResources', name: 'CulturalResources', component: CulturalResources, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/CulturalResource/:culturalResourceId?', name: 'CulturalResource', component: CulturalResource, beforeEnter: requireAuth, meta: { restrictedRoles: roleService.RestrictedRoleList } },
        { path: '/BuildingReconSiteSelection/:buildingSurveyId?', name: 'BuildingReconSiteSelection', component: BuildingReconSiteSelection, beforeEnter: requireAuth },
        { path: '/Callback', name: 'Callback', component: Callback },
        {
            path: '/LetterTemplates',
            name: 'LetterTemplates',
            component: LetterTemplates,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        {
            path: '/LetterTemplate/:letterTemplateId?',
            name: 'LetterTemplate',
            component: LetterTemplate,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        {
            path: '/UserAdministration',
            name: 'UserAdministration',
            component: UserAdministration,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        //{ path: '/RadioCarbonReport/:radioCarbonReportId?', name: 'RadioCarbonReport', component: RadioCarbonReport, props: true, beforeEnter: requireAuth },
        {
            path: '/ProjectsDelete',
            name: 'ProjectsDelete',
            component: ProjectsDelete,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        { path: '/E106Compliance/:e106complianceId?', name: 'E106Compliance', component: E106Compliance, beforeEnter: requireAuth },
        { path: '/E106Compliances', name: 'E106Compliances', component: E106Compliances, beforeEnter: requireAuth },
        {
            path: '/BlmDataExport',
            name: 'BlmDataExport',
            component: BlmDataExport,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        { path: '/HelpInfo', name: 'HelpInfo', component: HelpInfo, beforeEnter: requireAuth },
        { path: '/Reports', name: 'Reports', component: Reports, beforeEnter: requireAuth },
        {
            path: '/Reports/ShpoAnnualReport',
            name: 'ShpoAnnualReport',
            component: ShpoAnnualReport,
            beforeEnter: requireAuth,
            meta: { userRoles: roleService.AdminRoleList }
        },
        { path: '/PublicE106', name: 'PublicE106', component: PublicE106 }
    ],
    scrollBehavior (to, from, savedPosition) {
        return {x: 0, y: 0}
    }
})

router.beforeEach((to, from, next) => {
    loggingService.log(isDebug, 'router_index', 'beforeEach')
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js